import getUnitTextLabel from "views/components/visualizations/utils/getUnitTextLabel";
import { formatNumber } from "util/NumberFormatting";
const formatValueWithUnitLabel = (value, abbrev, minimumDigits = 1) => `${formatNumber(Number(value), { minimumDigits })} ${getUnitTextLabel(abbrev)}`;
export default formatValueWithUnitLabel;
